import React, { useState, useEffect } from 'react';

const API_BASE = 'https://nfl-touchdown-analyzer-api.lockgenerator.workers.dev';

function AppWorking() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/analysis`)
      .then(response => response.json())
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <h1>🏈 NFL Touchdown Analyzer</h1>
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <h1>🏈 NFL Touchdown Analyzer</h1>
        <p style={{color: 'red'}}>Error: {error}</p>
      </div>
    );
  }

  return (
    <div style={{padding: '20px'}}>
      <h1>🏈 NFL Touchdown Analyzer - Week {data?.current_week}</h1>

      <h2>🎯 Recommended Parlay</h2>
      {data?.parlay_recommendations?.picks?.map((player, index) => (
        <div key={index} style={{
          border: '1px solid #ccc',
          margin: '10px 0',
          padding: '10px',
          borderRadius: '5px'
        }}>
          <h3>{player.name} ({player.position}, {player.team})</h3>
          <p>Odds: +{player.odds_info?.odds}</p>
          <p>Touchdowns: {player.total_touchdowns}</p>
          <p>Snap %: {player.snap_percentage}%</p>
        </div>
      ))}

      <div style={{marginTop: '20px', padding: '10px', backgroundColor: '#f0f0f0'}}>
        <h3>📊 Parlay Summary</h3>
        <p>Probability: {(data?.parlay_recommendations?.parlay_true_probability * 100)?.toFixed(1)}%</p>
        <p>Expected Value: +{data?.parlay_recommendations?.expected_parlay_value?.toFixed(2)}</p>
      </div>
    </div>
  );
}

export default AppWorking;